module.exports = __webpack_public_path__ + "img/welding-3.64cac9b7.jpg";